import { styled } from '@mui/material';

export const Spacer = styled('div')<{ h?: number; w?: number }>`
  ${({ h }) => (h ? `height: ${h / 16}rem` : '')}
  ${({ w }) => (w ? `width: ${w / 16}rem` : '')}
`;
